import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent as CloseIcon } from './imgs/close-icon.svg';

// import Button from '@mail-ui/accounts-repair.button';
import Button from '../Button';

if (process.env.MAIL_APP_PLATFORM === 'h5') {
    require('./style_h5.scss');
} else {
    require('./style.scss');
}

const modalRoot = document.getElementById('modal-root') as HTMLElement;

export interface IModalbox {
    onCancel?: () => any,
    onSure?: () => any,
    onClose?: () => any,
    showClose?: boolean,
    cancelText?: string,
    sureText?: string,
    title: string | ReactElement,
    extraClass?: string,
    enableMarkClose?: boolean
}

const ModalBox: React.FC<IModalbox> = ({ children, title, cancelText, sureText, onCancel, onSure, onClose, showClose = true, extraClass, enableMarkClose = true }) => {
    const ModalContent = (
        <div className="modal-box-bg">
            <div className={`modal-box-wrapper ${extraClass ? extraClass : ''}`}>
                {showClose ? <CloseIcon className="modal-box-close-icon" onClick={onClose} /> : null}
                {title ? <h1>{title}</h1> : null } 
                <div className="modal-box-content">
                    {children}
                </div>
                {(cancelText || sureText) ?
                    <div className="modal-box-action-bar">
                        {cancelText ? <Button extraClass="modal-box-btn modal-box-cancel-btn" onClick={onCancel} text={cancelText || '取消'} /> : null}
                        {sureText ? <Button extraClass="modal-box-btn" color="primary" onClick={onSure} text={sureText || '确认'} /> : null}
                    </div> : null}
            </div>
            <div className="modal-box-mark" onClick={() => {enableMarkClose && showClose && onClose && onClose()}}></div>
        </div>
    )
    return (
        ReactDOM.createPortal(
            ModalContent,
            modalRoot
        )
    )
}

export default ModalBox;
